// extracted by mini-css-extract-plugin
export default {"question":"styles_question__qVv34","question__title":"styles_question__title__P9DE1"};